export const NAV_COLLAPSE_COOKIE = "nav_collapsed";
